'use client'

import { BUTTON_VARIANT } from 'fukku/Button/Button.types'
import { ButtonContentLink } from 'fukku/Button/ContentLink'
import { Content } from 'fukku/Dialog/Content/Content'
import type { DialogAPI } from 'fukku/Dialog/Dialog'
import { Header } from 'fukku/Dialog/Header/Header'
import { SideSheet } from 'fukku/Dialog/SideSheet/SideSheet'
import type React from 'react'
import { useRef } from 'react'
import { cx } from 'utils/cx'

import { dataTestIds } from '../../../constants/dataTestIds/dataTestIds'
import { useAnalytics } from '../../../contexts/AnalyticsProvider/AnalyticsProvider'
import { PdpActionEvents } from '../../../types/PdpActionEvents'

type PropertiesWrapperProps = {
	readonly className?: string
	readonly children: React.ReactElement
	readonly title: string
}

export function PropertiesWrapper({
	className,
	children,
	title,
}: PropertiesWrapperProps): React.ReactNode {
	const modalRef = useRef<DialogAPI>(null)
	const { sendPdpActionEvent } = useAnalytics()

	const onPropertiesClick = (): void => {
		modalRef.current?.show()
		sendPdpActionEvent(PdpActionEvents.PRODUCT_CARE)
	}

	return (
		<div className={cx(className)}>
			<div
				data-testid={
					dataTestIds['pdp.productDetails.compositionOriginAndCare.accordion']
				}
			>
				<ButtonContentLink
					variant={BUTTON_VARIANT.DEFAULT}
					className={className}
					onClick={onPropertiesClick}
					data-testid={
						dataTestIds['pdp.productDetails.compositionOriginAndCare.content']
					}
				>
					{title}
				</ButtonContentLink>
				<SideSheet ref={modalRef} title={title}>
					<Header title={title} />
					<Content>{children}</Content>
				</SideSheet>
			</div>
		</div>
	)
}
